export default function blacklist(
  state = {
    analyzeResults: null,
    isAnalyzing: false,
    isPosting: false,
    blacklistSubmitted: false
  },
  action
) {
  switch (action.type) {
    case 'POST_BLACKLIST_STARTED':
      return {
        isPosting: true,
        blacklistSubmitted: false
      }

    case 'POSTED_BLACKLIST':
      return {
        isPosting: false,
        blacklistSubmitted: true
      }

    case 'CLEAN_POSTED_BLACKLIST':
      return {
        blacklistSubmitted: false
      }

    case 'GET_BLACKLIST_ANALYZE_STARTED':
      return {
        ...state,
        isAnalyzing: true
      }

    case 'GET_BLACKLIST_ANALYZE_FAILED':
      return {
        ...state,
        error: action.payload.message,
        isAnalyzing: false
      }

    case 'GOT_BLACKLIST_ANALYZE':
      return {
        ...state,
        isAnalyzing: false,
        error: null,
        analyzeResults: action.payload
      }

    case 'CLEAN_BLACKLIST_ANALYZE':
      return {
        ...state,
        analyzeResults: null,
        isLoading: false,
        error: null
      }

    default:
      return state
  }
}
